import React, { useState } from 'react';
import {
  moveOnToNextPage,
  setStage,
  submitResponse
} from '../redux/actions/ui';

import {
  Panel,
  setSideBarDisabled,
  setSideBarInfo,
  setSideBarOpenPanel,
  setSideBarSecondTry
} from '../sidebar-state';
import { ProblemStage, EvalData, PeerEvalComp } from 'its-pages';
import { SubmitBar } from '../components/submit-bar';
import { EvalContent } from '../page-content/eval-content';
import { useAppDispatch, useAppSelector } from '../redux/hooks';

const next = 'Next';
const nextQuestion = 'Next Question';
const submit = 'Submit';
const buttonTextMap: { [key in ProblemStage]: string } = {
  [ProblemStage.ReadTranscript]: next,
  [ProblemStage.CollectInput]: submit,
  [ProblemStage.Evaluate]: submit,
  [ProblemStage.SecondTry]: submit,
  [ProblemStage.ShowResult]: nextQuestion
};
//******************************************************************************
interface ComponentProps {
  content: EvalContent;
}


export const PeerEval = (props: ComponentProps) => {
  const dispatch = useAppDispatch();
  const correctAnswerStreak = useAppSelector((state) => state.progression.correctAnswerStreak);
  const stage = useAppSelector((state) => state.ui.stage);
  const pageData = props.content.pageData as EvalData;

  const [disableSubmit, setDisableSubmit] = useState(false);
  const showResult = stage === ProblemStage.ShowResult;

  // Workflow for this problem based on the submit button being clicked
  // - view the response that was created by another user
  // - pick whether traits were avoided or included
  // - finished
  const onSubmit = () => {
    const gotoShowResults = () => {
      dispatch(submitResponse());
      setSideBarInfo(<p>Thank you for your feedback.</p>);
      dispatch(setStage(ProblemStage.ShowResult));
    };

    const gotoEval = () => {
      setSideBarDisabled(Panel.ResouceTips, false);
      setDisableSubmit(true);
      dispatch(setStage(ProblemStage.Evaluate));
    };

    if (showResult) {
      dispatch(moveOnToNextPage());
    } else if (stage === ProblemStage.ReadTranscript) {
      gotoEval();
    } else if (stage === ProblemStage.Evaluate) {
      gotoShowResults();
    }
  };

  const onReviewed = () => {
    if (showResult) {
      setSideBarOpenPanel(Panel.None);
    }
  };

  const onChange = () => {
    switch (stage) {
      case ProblemStage.SecondTry: {
        setDisableSubmit(false);
        break;
      }
      case ProblemStage.Evaluate: {
        const { evalAnswers, tagsToAvoid } = pageData;
        const evalLength = Object.keys(evalAnswers).length;
        const avoidLength = Object.keys(tagsToAvoid).length;

        // +1 to include the tag we're looking for
        if (evalLength >= avoidLength + 1) {
          setDisableSubmit(false);
        }
      }
    }
  };

  return (
    <>
      <PeerEvalComp
        pageData={pageData}
        stage={stage}
        onReviewed={onReviewed}
        onChange={onChange}
      />
      <SubmitBar
        onSubmit={onSubmit}
        disableSubmit={disableSubmit}
        buttonText={buttonTextMap[stage]}
        buttonClass={'SubmitBarButton'}
      />
    </>
  );
};
